import type { SVGProps } from 'react'

export interface OrderIconProps extends SVGProps<SVGSVGElement> {
  /** Icon size */
  size?: number
}

/**
 * OrderIcon - List/order icon for order summary header
 * Design from Figma node 468:1960
 */
export function OrderIcon({ size = 22, className, ...props }: OrderIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#order-icon-clip)">
        <path
          d="M17.8824 22H4.11765C2.94765 22 2 20.9471 2 19.6471V4.35294C2 3.05294 2.94765 2 4.11765 2H17.8824C19.0524 2 20 3.05294 20 4.35294V19.6471C20 20.9412 19.0524 22 17.8824 22Z"
          fill="#24C790"
        />
        <path
          d="M14.8285 3.96875H7.6285C6.3025 3.96875 5.2285 3.07375 5.2285 1.96875C5.2285 0.86375 6.3025 -0.03125 7.6285 -0.03125H14.8285C16.1545 -0.03125 17.2285 0.86375 17.2285 1.96875C17.2285 3.07375 16.1545 3.96875 14.8285 3.96875Z"
          fill="#FFD43F"
        />
        <path
          d="M11.5502 10.8571H5.88905C5.13345 10.8571 4.52174 10.2743 4.52174 9.55429V9.30286C4.52174 8.58286 5.13345 8 5.88905 8H11.5502C12.3058 8 12.9176 8.58286 12.9176 9.30286V9.55429C12.9157 9.89929 12.771 10.2296 12.515 10.4736C12.2589 10.7175 11.9123 10.8554 11.5502 10.8571ZM14.6267 16H5.3733C5.0091 16 4.65978 15.8621 4.40223 15.6167C4.14469 15.3713 4 15.0385 4 14.6914V14.4457C4 14.2739 4.03552 14.1037 4.10453 13.945C4.17355 13.7862 4.27471 13.642 4.40223 13.5204C4.52976 13.3989 4.68115 13.3025 4.84777 13.2367C5.0144 13.171 5.19295 13.1371 5.3733 13.1371H14.6267C14.807 13.1371 14.9856 13.171 15.1522 13.2367C15.3189 13.3025 15.4702 13.3989 15.5978 13.5204C15.7253 13.642 15.8265 13.7862 15.8955 13.945C15.9645 14.1037 16 14.2739 16 14.4457V14.6914C16 14.8633 15.9645 15.0334 15.8955 15.1922C15.8265 15.351 15.7253 15.4952 15.5978 15.6167C15.4702 15.7383 15.3189 15.8347 15.1522 15.9004C14.9856 15.9661 14.807 16 14.6267 16Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="order-icon-clip">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
